export default __webpack_public_path__ + "static/media/1718 cutlery side.cfb2859d.png";